// Device fingerprinting utility - OPTIMIZED for smaller size
export const generateDeviceFingerprint = (): string => {
    // Create a much smaller fingerprint without canvas data
    const fingerprint = [
        navigator.userAgent.substring(0, 100), // Limit user agent length
        navigator.language,
        screen.width + 'x' + screen.height,
        new Date().getTimezoneOffset(),
        navigator.hardwareConcurrency || '0',
        (navigator as any).deviceMemory || '0',
        navigator.platform,
        window.devicePixelRatio || '1'
    ].join('|');
    
    // Create a hash of the fingerprint
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
        const char = fingerprint.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    
    return Math.abs(hash).toString(36);
}; 